import React, { useCallback, useEffect, useState } from 'react';
import { ChevronRight, ExpandMore } from '@material-ui/icons';
import { Link as RouterLink } from 'react-router-dom';
import { IconButton, makeStyles } from '../..';

const useStyles = makeStyles((theme) => ({
  btn: {
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.primary.main,
    },
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(1),
  },
  firstChild: {
    paddingLeft: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  secondChild: {
    paddingLeft: theme.spacing(7),
  },
}));

export interface ExpandableCellLinkProps {
  value: string | number;
  linkTemplate: string;
  openNewTab?: boolean;
  node?: any;
}

export const ExpandableCellLink: React.FC<ExpandableCellLinkProps> = ({
  value,
  node,
  linkTemplate,
  openNewTab,
}): React.ReactElement | null => {
  const classes = useStyles();
  const link = linkTemplate?.replace(':value', String(value));
  const [isExpanded, setIsExpanded] = useState(node.expanded);

  const handleExpand = useCallback(() => {
    node.setExpanded(!node.expanded);
    setIsExpanded(node.expanded);
  }, [node]);

  useEffect(() => {
    setIsExpanded(node.expanded);
  }, [node.expanded]);

  if (!link) {
    return <>{value}</>;
  }

  if (node.level === 0) {
    return (
      <div>
        <IconButton disableRipple size="small" onClick={handleExpand} className={classes.btn}>
          {isExpanded ? <ExpandMore style={{ fontSize: 'large' }} /> : <ChevronRight style={{ fontSize: 'large' }} />}
        </IconButton>
        {openNewTab ? (
          <a href={link} target="_blank" rel="noopener noreferrer">
            {value}
          </a>
        ) : (
          <RouterLink to={link}>{value}</RouterLink>
        )}
      </div>
    );
  } else if (node.childrenAfterGroup?.length) {
    return (
      <div className={classes.firstChild}>
        <IconButton disableRipple size="small" onClick={handleExpand} className={classes.btn}>
          {isExpanded ? <ExpandMore style={{ fontSize: 'large' }} /> : <ChevronRight style={{ fontSize: 'large' }} />}
        </IconButton>
        <div>{value}</div>
      </div>
    );
  } else {
    return <div className={classes.secondChild}>{value}</div>;
  }
};
